"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoContainer = void 0;
exports.mapStateToProps = mapStateToProps;
var _reactRedux = require("react-redux");
var _selectors = require("./selectors");
var _PhoneCallConfirmationInfo = require("../../../../components/PhoneCallConfirmationInfo");
function mapStateToProps(state) {
  return {
    phone: (0, _selectors.formattedPhoneSelector)(state)
  };
}
const InfoContainer = exports.InfoContainer = (0, _reactRedux.connect)(mapStateToProps)(_PhoneCallConfirmationInfo.PhoneCallConfirmationInfo);